exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal[data-v-5faf8778] {\n  pointer-events: none;\n}\n.modal .modal-body[data-v-5faf8778] {\n  max-height: 80vh;\n  overflow-x: hidden;\n  overflow-y: auto;\n}", ""]);

// exports
